import SliderFA from './fa/fa.json'

const SliderMessages = {
  fa: { ...SliderFA },
}

export default SliderMessages
